import styled from "styled-components/macro";

export const StatusSelectorWrapper = styled.div`
width: 180px; 
margin-top: 40px;
@media (max-width: 991px) {
    display: none; 
}
`